<template>
  <div class="pinm">
    <!-- <el-radio-group v-model="isCollapse">
      <el-radio-button :label="false">展开</el-radio-button>
      <el-radio-button :label="true">收起</el-radio-button> -->
    <!-- </el-radio-group> -->
    <!--    <el-menu default-active="1-4-1" class="el-menu-vertical-demo" background-color="#3a3c3f" text-color="#fff" :collapse="isCollapse">-->
    <!--      <div style="margin-top: 13%;text-align: center;" @click.stop="isCollapse = !isCollapse"><i class="el-icon-arrow-left ics" v-if="isCollapse==false"></i><i class="el-icon-arrow-right ics" v-else></i></div>-->
    <!--      <router-link v-for="item in items_list" :key="item.id" :to="item.path">-->
    <!--        <el-menu-item :index='item.id'>-->
    <!--          <v-icon class="ic" style="color: #afb0b4;font-size: 20px;">{{item.icon}}</v-icon>-->
    <!--          <span slot="title" >{{item.label}}</span>-->
    <!--        </el-menu-item>-->
    <!--      </router-link>-->
    <!--    </el-menu>-->
    <div class="to">
      <div class="tobu">
        <div class="header">

              <div class="nav-menu-warp">
                <div class="menu-list2">
                  <div
                    ref="menuLogo"
                    class="menu-logo"
                    :style="
                      __APP_CONFIG__.appLogo
                        ? 'background-image: url(' +
                          host_url +
                          __APP_CONFIG__.appLogo +
                          ')'
                        : ''
                    "
                  ></div>
                <div class="nav-menu-list">
                  <div class="nav-menu-list-ul" ref="navMenuList">

                    <template v-for="(item, index) in item">
                      <!-- 跳转新页面 -->
                      <a class="menu-item" v-if="item.path.indexOf('http') === 0" :href="item.path" target="_blank" :key="item.id">
                        <span slot="title">{{ item.label }}</span>
                      </a>

                      <!-- 普通路由跳转 -->
                      <router-link v-else-if="item.path"
                        class="menu-item"
                        :class="{ act: index === menu_level_1_index }"
                        :key="item.id"
                        :to="item.path"
                        @click.native="
                          menuName = item.label;
                          menu_level_1_index = index;
                        "
                      >
                        <span>{{ item.label }}</span>
                      </router-link>
                      <div class="menu-item" v-else @click="
                          menuName = item.label;
                          menu_level_1_index = index;
                        " :key="item.id">
                        <span>{{ item.label }}</span>
                      </div>
                    </template>

                  </div>
                  <div class="nav-menu-more" id="navMenuMore" v-show="showNavMenuMore">
                    <i class="el-icon-menu"></i>
                  </div>
                <!-- <a class="menu-icon">...</a> -->
                </div>
              </div>

              <div class="rights" ref="loginInfo">
                <div style="display: flex; justify-content: flex-end;">
                  <a href="#">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="权限切换"
                      placement="top-start"
                    >
                      <i class="el-icon-share weiz" @click="quanxianqh"></i>
                    </el-tooltip>
                  </a>
                  <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                      <span class="login-name">{{ login }} 到家科技管理后台</span><i
                        class="el-icon-arrow-down el-icon--right"
                      ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                      ><div @click="refreshPermisson()">刷新权限</div></el-dropdown-item
                      >
                      <el-dropdown-item
                        ><div @click="xiugai()">修改密码</div></el-dropdown-item
                      >
                      <el-dropdown-item
                        ><div @click="tchu()">退出登录</div></el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>

            </div>




        </div>

        <div class="ti">

          <div class="left-wrap" :class="{hide: hideMenu}">

            <div
              class="ti-left"
            >
              <el-menu
                default-active="1-4-1"
                mode="vertical"
                class="el-menu-vertical-demo"
                background-color="#545c64"
                text-color="#fff"
                active-text-color="#eeeeee"
                :collapse="false"

                v-if="
                  item[menu_level_1_index] &&
                  item[menu_level_1_index].children &&
                  item[menu_level_1_index].children.length
                "
              >
                <template v-for="item1 in item[menu_level_1_index].children">
                  <template
                    v-if="
                      item1.children && item1.children.length && !item1.is_menu
                      && item1.label !== '首页内容'
                    "
                  >
                    <el-submenu class="sub-menu" :index="item1.id + ''">
                      <template slot="title">
                        <!--                      <v-icon v-if="item1.icon" class="ic" style="color: #ffffff;font-size: 14px;">{{ item1.icon }}</v-icon>-->
                        <!--                      <v-icon v-if="!item1.icon" class="ic" style="color: rgba(255,255,255,0);font-size: 14px;">1</v-icon>-->
                        <!--                      <i v-if="item1.icon" :class="item1.icon"></i>-->
                        <span>{{ item1.label }}</span>
                      </template>
                      <template v-for="item2 in item1.children || []">

                        <template v-if="item2.is_menu == true && (item2.children && item2.children.length)">
                          <el-submenu :index="item2.id + ''" class="sub-menu-2">
                            <template slot="title">
                              <span style="padding-left: 8px;">{{ item2.label }}</span>
                            </template>

                            <template v-for="item3 in item2.children || []">

                              <!-- 跳转新页面 -->
                              <a v-if="item3.path.indexOf('http') === 0" :href="item3.path" target="_blank">
                                <el-menu-item :index="item3.id + ''">
                                  <span slot="title">{{ item3.label }}</span>
                                </el-menu-item>
                              </a>

                              <router-link v-else :key="item3.id" :to="item3.path">
                                <el-menu-item :index="item3.id + ''">
                                  <span style="padding-left: 16px;" slot="title">{{ item3.label }}</span>
                                </el-menu-item>
                              </router-link>


                            </template>

                          </el-submenu>
                        </template>

                        <template v-else>

                          <!-- 跳转新页面 -->
                          <a v-if="item2.path.indexOf('http') === 0" :href="item2.path" target="_blank">
                            <el-menu-item :index="item2.id + ''">
                              <span slot="title">{{ item2.label }}</span>
                            </el-menu-item>
                          </a>


                          <router-link  v-else :key="item2.id" :to="item2.path">
                            <el-menu-item :index="item2.id + ''">
                              <span slot="title">{{ item2.label }}</span>
                            </el-menu-item>
                          </router-link>




                        </template>

                      </template>
                    </el-submenu>
                  </template>
                  <template
                    v-if="
                      !item1.children || !item1.children.length || item1.is_menu
                    "
                  >
                    <!-- 跳转新页面 -->
                    <a v-if="item1.path.indexOf('http') === 0" :href="item1.path" target="_blank">
                      <el-menu-item :index="item1.id + ''">
                        <span slot="title">{{ item1.label }}</span>
                      </el-menu-item>
                    </a>
                    <!-- 普通路由跳转 -->
                    <router-link v-else :key="item1.id" :to="item1.path">
                      <el-menu-item :index="item1.id + ''">
                        <span slot="title">{{ item1.label }}</span>
                      </el-menu-item>
                    </router-link>
                  </template>
                </template>
              </el-menu>
            </div>

            <div class="hide-menu">
              <a class="hide-menu-btn" @click="hideMenu = true">
                <i class="el-icon-arrow-left"></i>
              </a>
            </div>

          </div>
          <div id="ti-right" class="ti-right">
            <tags-view></tags-view>
            <!-- <div :class="rightMain"> -->
            <div class="right-main">
              <transition>
                <keep-alive>
                  <router-view></router-view>
                </keep-alive>
              </transition>
            </div>
          </div>
        </div>
        <!--        <div class="dibu">-->
        <!--          版权所有&nbsp;&nbsp;&copy到家科技&nbsp;&nbsp;|&nbsp;&nbsp;邮编：000000&nbsp;&nbsp;|&nbsp;&nbsp;反馈意见：its@qq.com-->
        <!--        </div>-->
      </div>
    </div>

    <div class="task-button">
      <el-badge :value="excelTaskCount > 0 ? excelTaskCount : ''">
        <el-button
          type="primary"
          @click="openExcelTask()"
          icon="el-icon-download"
          round
        />
      </el-badge>
      <div style="height: 10px;"></div>
      <el-popover
        title="AI助手"
        width="200"
        trigger="hover"
        placement="left-start"
        content="系统咨询问答的好助手，随时随地为您解答。">
        <el-button
          type="primary"
          @click="openAi()"
          icon="el-icon-chat-dot-round"
          title="AI助手"
          round
          slot="reference"
        />
      </el-popover>

<!--      <div style="height: 10px;"></div>-->
<!--      <el-badge>-->
<!--        <el-button-->
<!--          type="primary"-->
<!--          @click="$refs.QueueTaskTip.show()"-->
<!--          icon="el-icon-s-data"-->
<!--          round-->
<!--        />-->
<!--      </el-badge>-->
<!--      <div style="height: 10px;"></div>-->
<!--      <el-badge>-->
<!--        <el-button-->
<!--          type="primary"-->
<!--          @click="$refs.ChatIMDialog.show()"-->
<!--          icon="el-icon-message"-->
<!--          round-->
<!--        />-->
<!--      </el-badge>-->
    </div>


    <Modal
      v-model="modal1add"
      ok-text="保存"
      width="460"
      title="修改密码"
      @on-ok="ok"
    >
      <el-form label-width="80px">
        <el-form-item label="密码">
          <el-input v-model="dades.pwd" @keyup.enter.native="ok()"></el-input>
        </el-form-item>
      </el-form>
    </Modal>

    <Modal
      v-model="modal1add"
      ok-text="保存"
      width="460"
      title="修改密码"
      @on-ok="ok"
    >
      <el-form label-width="80px">
        <el-form-item label="密码">
          <el-input v-model="dades.pwd"></el-input>
        </el-form-item>
      </el-form>
    </Modal>

    <Modal
      v-model="qxqh"
      ok-text="切换"
      width="460"
      title="权限切换"
      @on-ok="oks"
    >
      <el-form label-width="80px">
        <el-form-item label="权限">
          <el-select v-model="value" placeholder="请选择权限">
            <el-option key="" label="自己的权限" value=""> </el-option>
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </Modal>

    <excel-task ref="ExcelTask" :excelTask="excelTask" @close="closeExcelTask" />
<!--    <QueueTaskTip ref="QueueTaskTip"/>-->
<!--    <ChatIMDialog ref="ChatIMDialog"/>-->

    <div class="show-menu" :class="{show: hideMenu}">
      <a class="show-menu-btn" @click="hideMenu = false">
        <i class="el-icon-arrow-right"></i>
      </a>
    </div>

  </div>
</template>

<script>
import menu_tree from "../assets/js/tree";
import App from "../App.vue";
import { Loading } from "element-ui";
import ERP from "../assets/lib/ERP";
import TagsView from "./common/tagsView/index";
import ExcelTask from "./common/excelTask";
// import QueueTaskTip from "./Admin/Common/queue-task/QueueTaskTip";
// import ChatIMDialog from "./Admin/Common/chat/ChatIMDialog";
export default {
  components: {
    // ChatIMDialog, QueueTaskTip,
    App, TagsView, ExcelTask },
  name: "erp-index",
  data() {
    return {
      host_url: "",
      modal1add: false,
      qxqh: false,
      value: "",
      options: [],
      isCollapse: false,
      login: "",
      item: [],
      dades: { pwd: "" },
      excelTask: false,
      items_list: [
        {
          id: "1",
          label: "大屏",
          icon: "mdi-home-outline ",
          path: "/",
        },
        {
          id: "2",
          label: "项目",
          icon: "mdi-archive-outline ",
          path: "/pindex",
        },
        // {
        //   id:'3',
        //   label: '订单',
        //   icon: 'mdi-form-select ',
        //   path:'/order',
        // },
        // {
        //   id:'4',
        //   label: '会员',
        //   icon: 'mdi-account ',
        //   path:'/User',
        // },
        {
          id: "4",
          label: "业主管理",
          icon: "mdi-account ",
          path: "/User",
        },
        {
          id: "5",
          label: "财务管理",
          icon: "mdi-chart-line  ",
          path: "/Finance",
        },
        {
          id: "6",
          label: "操作",
          icon: "mdi-file-document-outline ",
          path: "/Operation",
        },
        {
          id: "7",
          label: "架构",
          icon: "mdi-account-cog-outline ",
          path: "/Jindex",
        },
        {
          id: "10",
          label: "应用",
          icon: "mdi-view-grid",
          path: "/App",
        },
        {
          id: "9",
          label: "小程序",
          icon: "mdi-link-variant ",
          path: "/Applets",
        },
        {
          id: "8",
          label: "设置",
          icon: "mdi-eslint ",
          path: "/mb",
        },
      ],
      menu_level_1_index:
      window.localStorage.getItem("menu_level_1_index") || 0,
      showMenu: false,
      menuName: "主菜单",
      loadUI: null,
      showNavMenuMore: false,
      activeIndex: '1',
      hideMenu: false,
      rightMain:'right-main',
    };
  },
  watch: {
    menu_level_1_index: function (n) {
      // console.log(n,this.item[n],this.item)
      window.localStorage.setItem("menu_level_1_index", n);
    },
    //监听路由
    // '$route' (to, from) { //监听路由是否变化
    //   let urlPath = ['/order/order'];
    //   //判断数组中是否存在，// 不存在=>返回-1，存在返回下标
    //   let boot = urlPath.indexOf(to.path);
    //   var strs = new Array();
    //   strs = to.path.split("/");
    //   if(strs.length >= 1){
    //     if(strs[1] == 'pindex'){
    //       boot = 0;
    //     }
    //     if(strs[1] == 'meter'){
    //       boot = 0;
    //     }
    //     if(strs[1] == 'order'){
    //       boot = 0;
    //     }
    //     if(strs[1] == 'Comparison'){
    //       boot = 0;
    //     }
    //   }
    //   if(boot != -1){
    //     this.rightMain = 'right-main2';
    //   }else{
    //     this.rightMain = 'right-main';
    //   }
    // }
  },
  //界面没出来前加载
  created() {
    this.items_list = menu_tree;
    this.host_url = this.$myhttp.defaults.baseURL;
  },
  mounted() {
    this.login = window.localStorage.getItem("login");
    this.getMenuTree();
    this.getMenuAllTree();

    window.addEventListener('resize', this.resize, true)

    // TODO 暂时使用
    if(!window.localStorage.getItem('search-condition')){
      window.localStorage.setItem('search-condition','{"typeId":1,"regionId":"","projectId":"","areaId":""}')
    }
  },
  unmounted() {
    window.removeEventListener('resize', this.resize, true)
  },
  computed: {
    __APP_CONFIG__() {
      return ERP.getStore().__APP_CONFIG__;
    },
    cachedViews() {
      // console.log(this.$store)
      return this.$store.state.tagsView.cachedViews;
    },
    excelTaskCount(){
      return this.$store.state.excelTaskCount;
    },
    key() {
      return this.$route.path;
    },
  },
  methods: {
    //权限切换查询权限
    quanxianqh() {
      this.$Loading.start();
      this.$myhttp
        .get("admin/gatQuanxianqh", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          // 异步执行成功后
          if (backdata.data["code"] == 201) {
            this.$Message.success("没有其它权限");
          } else {
            this.options = backdata.data[0];
            if (backdata.data[1] != 0 && backdata.data[1] != backdata.data[2]) {
              this.value = backdata.data[2];
            }
            this.qxqh = true;
          }
          this.$Loading.finish();
        });
    },
    //权限切换保存
    oks() {
      console.log(this.value);
      var date = { jid: this.value };
      this.$myhttp
        .post("admin/quanxianqhUpdate", date, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.$Message.success("切换成功");
          if (backdata.data == 200) {
            location.reload(); //刷新
          }
        });
    },
    xiugai() {
      this.modal1add = true;
    },
    refreshPermisson() {
      ERP.postRequest({url:"admin/refreshPermisson", data:{}}, (ret) => {
        if (ret.code == 200) {
          this.$Message.success("刷新成功");
          setTimeout(() => {
            location.reload(); //刷新
          }, 1000);
        } else {
          this.$Message.error("刷新失败");
        }
      });
    },
    //保存密码
    ok() {
      if (this.dades.pwd == "") {
        this.$Message.error("保存密码不能为空!");
        return false;
      }
      this.$Loading.start();
      this.$myhttp
        .post("admin/userpwdupdate", this.dades, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.$Loading.finish();
          this.$Message.success("修改成功");
          this.dades = { pwd: "" };
        });
    },
    tchu() {
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("oa_user_id");
      this.$router.push({ name: "login" });
    },
    getMenuTree() {
      var that = this;
      // that.item = menu_tree;
      window.Loadings = Loading.service({ fullscreen: true });
      // that.loadUI=Loading.service({ fullscreen: true });
      that.$myhttp.get("admin/getMenuTree").then(({ data } = ret) => {
        // console.log('getMenuTree',data);
        if (data&&data.code) {
          if (typeof data.data === "object") {
            that.item = data.data;
          } else {
            that.item = menu_tree;
          }
          // that.item = menu_tree;
          ERP.setStore(
            "__USER_MENU_LIST__",
            JSON.parse(JSON.stringify(that.item))
          ); //用户权限目录树
          ERP.getTreePermissionIds(true); //权限重载
        } else {
          that.$msgbox.alert("登录超时，请重新登录！");
          that.item = [];
        }
        window.Loadings.close();
        setTimeout(this.resize, 20)
        // that.loadUI.close();
      });
    },
    getMenuAllTree() {
      ERP.getMenuAllTree();
    },
    openExcelTask() {
      this.$store.commit('excelTaskClear');
      this.excelTask = true;
      this.$refs.ExcelTask.change(1);
    },
    closeExcelTask() {
      this.excelTask = false;
    },
    resize() {

      // const leftWidth = this.$refs.menuLogo.offsetWidth
      // const rightWidth = this.$refs.loginInfo.offsetWidth
      const menuHeight = this.$refs.navMenuList.scrollHeight

      this.showNavMenuMore = menuHeight > 45
    },
    openAi() {
      window.open("https://meter.gdzawy.com/chatAi/#/chat?chatAppId=1", "_blank","width=800,height=1000,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,status=no");
    },
  },
};
</script>

<style lang="scss" scoped>
.el-button--primary,.el-button--success,.el-button--danger,.el-button--warning {
  color: #FFF;
}
.pinm {
  display: flex;
  height: 100%;
  width: 100%;
  //小于1401px给宽度1500px
  @media screen and (max-width: 1201px) {
    width: 1200px;
  }
  //大于1400px，给100%
  @media screen and (min-width: 1400px) {
    width: 100%;
  }
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 135px;
  height: 100%;
}
.el-menu {
  height: 100%;
  border-right: none;
}
.to {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  width: 100%;
}
.tobu {
  display: flex;
  width: 100vw;
  height: 100vh;
  flex-direction: column;
}
.lis {
  background-color: #6f7175;
}
.rights {
  width: 100%;
  height: 45px;
  text-align: right;
  font-size: 6px;
  padding-right: 10px;
  max-width: 220px;
}
.ti {
  width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: row;
  flex: 1;

  .left-wrap {
    display: flex;
    flex-direction: column;
    width: 135px;
    overflow: hidden;
    transition: all .1s ease-in-out;

    &.hide {
      width: 0;
    }

    .hide-menu {
      height: 40px;
      background-color: #69747e;
      text-align: right;

      .hide-menu-btn {
        display: inline-block;
        width: 40px;
        height: 40px;
        color: #fff;
        font-size: 18px;
        line-height: 40px;
        text-align: center;
      }
    }
  }

  .ti-left {
    flex: 1;

    width: 135px;
    width: 135px;
    background-color: rgb(84, 92, 100);
    overflow-y: scroll;
    overflow-x: unset;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      color: transparent;
    }

    //.el-menu{
    //  background-color:#353535;
    //  color: #FFFFFF;
    //  .el-submenu .el-menu{
    //    background-color:#353535;
    //  }
    //  .el-submenu__title{
    //    color: #FFFFFF;
    //  }
    //  .el-menu-item{
    //    color: #FFFFFF;
    //  }
    //}
    .el-menu-vertical-demo:not(.el-menu--collapse) {
      width: 135px;
      height: 100%;
    }
    a {
      text-decoration: none;
    }

    .el-menu {
      a {
        .el-menu-item {
          padding-left: 10px !important;
          .el-submenu__icon-arrow {
            right: 10px;
          }
        }
      }
      .el-submenu {
        /deep/.el-submenu__title  {
          padding-left: 10px !important;
          .el-submenu__icon-arrow {
            right: 10px;
          }
        }
        .el-menu-item {
          min-width: 135px !important;
          width: 135px !important;
          padding-left: 20px !important;
          &:hover {
            min-width: 135px !important;
            width: 135px !important;
            padding-left: 20px !important;
          }
        }
      }
      .el-menu-item.is-active {
        //background-color: #3ab3a9 !important;//你要修改的颜色
        background-color: #30363e !important;
      }
    }
  }
  .ti-right {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex: 1;
  }

  .right-main {
    display: flex;
    //overflow: auto;//体内容的滚动条
    overflow: auto;//体内容的滚动条
    flex: 1;
    background: #fff;

    .daoh2 {
      width: 100%;
      height: fit-content;
      min-width: 1200px;
    }
  }

  .right-main2 {
    display: flex;
    //overflow: auto;//体内容的滚动条
    //小于1400px，显示滚动条
    @media screen and (max-width: 1500px) {
      overflow: auto;//体内容的滚动条
    }
    flex: 1;
    background: #fff;

    .daoh2 {
      width: 100%;
      height: fit-content;
      min-width: 1200px;
    }
  }
}
.dibu {
  width: 100%;
  height: 3%;
  text-align: center;
  background-color: white;
  line-height: 35px;
  font-size: 6px;
}
a {
  text-decoration: none;
}
.ic {
  font-size: 20px;
  color: #afb0b4;
  //margin-left: -10px;
}

.ics {
  color: #909399;
  width: 100%;
  background-color: rgb(63, 63, 62);
}
.el-dropdown-link {
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 6px;
  margin-bottom: 20px;
}
.weiz {
  margin-right: 8px;
}

.header {
  width: 100%;
  background-color: #1e73e9;
  height: 45px;
  line-height: 45px;
  .el-dropdown {
    color: #ffffff;
  }
}

$menu-name-width: 90px;
$menu-list-width: 250px;

.header-menu {
  position: relative;
  height: 45px;

  .menu-title {
    font-size: 16px;
    cursor: default;
    padding-left: 15px;
    background-color: #dedede;
    display: inline-block;
    position: relative;
    width: $menu-name-width;
    transition: all 0.1s ease-in-out;

    .el-icon-menu {
      margin-right: 3px;
      font-size: 18px;
    }

    .menu-name {
      display: flex;
      align-items: center;
      color: #222222;
    }

    &.show {
      box-shadow: 1px -1px 5px rgba(0, 0, 0, 0.4);

      .menu-list {
        visibility: visible;
        opacity: 1;
      }
    }

    .menu-list {
      position: absolute;
      left: 0;
      z-index: 9;
      width: $menu-list-width;
      background-color: #dedede;
      padding: 10px;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
      transition: all 0.1s ease-in-out;
      visibility: hidden;
      opacity: 0;
      border-radius: 1px;

      .menu-item {
        display: inline-block;
        width: 33.33%;
        text-align: center;
        line-height: 30px;
        color: #222222;
        font-size: 14px;
        border-radius: 3px;

        &:hover {
          background-color: #dedede;
          color: #000;
        }

        &:active {
          background-color: #dedede;
          color: #000;
        }
      }

      &::before {
        content: "";
        position: absolute;
        left: 0;
        width: $menu-name-width;
        top: -5px;
        height: 10px;
        background-color: #dedede;
      }
    }
  }
}
.menu-list2 {
  position: relative;
  display: flex;
  flex-direction: row;

  .menu-logo {
    width: 135px;
    height: 45px;

    background-image: url("../assets/logo.png");
    background-repeat: no-repeat;
    background-size: 120px;
    background-position: center;
  }
  .menu-item {
    display: inline-block;
    //width: 20px;
    height: 45px;
    line-height: 45px;
    padding: 0 10px;
    font-size: 16px;
    //font-weight: bold;
    color: #ffffff;
    cursor: pointer;
    &.act {
      background-color: rgba(255, 255, 255, 0.2);
    }
    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
}
.task-button {
  position: fixed;
  top: 80vh;
  right: 20px;
  //width: 30px;
  height: 150px;
  text-align: center;
  z-index: 999999999999;
  display: flex;
  flex-direction: column;
  .el-button{
    font-size: 16px;
  }
}

/deep/.el-submenu {
  .el-submenu__title {
    padding-left: 10px !important;
  }

  .el-menu-item {
    background-color: #485058 !important;
  }
}

/deep/.sub-menu-2 {
  .el-submenu__title {
    padding-left: 10px !important;
    background-color: #485058 !important;
  }

  .el-menu-item {
    background-color: #363d44 !important;
  }
}


.nav-menu-warp {
  display: flex;
  justify-content: space-between;
}


.nav-menu-list {
  position: relative;
  background-color: #1e73e9;
  display: flex;
  height: 45px;
  overflow: hidden;
  flex: 1;

  .nav-menu-list-ul {
    display: flex;
    flex-wrap: wrap;
  }

  .nav-menu-more {
    height: 45px;

    i {
      line-height: 45px;
      padding-right: 10px;
      font-size: 16px;
      color: #fff;
    }
  }

  .menu-icon {
    float: right;
  }

  &:hover {
    z-index: 9999;
    height: auto;
  }
}

.show-menu {
  position: absolute;
  left: 0;
  bottom: 20px;
  width: 25px;
  height: 40px;
  background-color: rgba(104, 115, 125, .6);
  text-align: center;
  transform: translateX(-100%);
  transition: all .1s ease-in-out;

  &.show {
    transform: translateX(0);
  }

  .show-menu-btn {
    font-size: 18px;
    color: #fff;
    line-height: 40px;
  }
}

.tags-view-container {
  z-index: 15
}

.login-name {
  display: inline-block;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>



// WEBPACK FOOTER //
// src/components/Index.vue